import { AdminBarberRepository } from "../../Repository";

export async function changeBusinessName(
  businessName: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.setBarberShopName(businessName);
}
